@if (promptCategory !== "SUMMARY") {
  <div class="flex flex-column gap-2 mb-4">
    <label for="promptLabel">
      <ng-container i18n="@@prompt_editor_prompt_name_label">Nom du prompt</ng-container>
    </label>
    <input
      [ngClass]="{ 'ng-invalid': promptLabel === '' }"
      pInputText
      id="promptLabel"
      [(ngModel)]="promptLabel"
    />
  </div>
}
<div class="mb-2">
  <ng-container i18n="@@prompt_editor_model_name_label">Modèle de langage (LLM)</ng-container>
  <i
    class="pi pi-question-circle"
    style="margin-left: 5px"
    tabindex="0"
    (mouseenter)="modelTooltip.show($event)"
    (focus)="modelTooltip.show($event)"
    (mouseout)="modelTooltip.hide()"
    (blur)="modelTooltip.hide()"
  ></i>
  <p-overlayPanel
    #modelTooltip
    [style]="{ width: '600px' }"
  >
    <span [innerHTML]="llmDescriptions"></span>
  </p-overlayPanel>
</div>
<p-dropdown
  [(ngModel)]="model"
  (ngModelChange)="onModelChange($event)"
  [options]="optionsModel"
  [group]="true"
  optionLabel="displayedName"
  optionValue="technicalName"
  [style]="{ width: '100%' }"
  placeholder="Modèle"
  i18n-placeholder="@@prompt_editor_model_dropdown_placehoder"
  appendTo="body"
>
  <ng-template
    let-group
    pTemplate="group"
  >
    <div class="flex align-items-center">
      <span>{{ group.label }}</span>
    </div>
  </ng-template>
</p-dropdown>
<div class="mt-4 mb-2 flex align-items-center">
  <div class="flex-grow-1">
    <ng-container i18n="@@prompt_editor_temperature_label">Créativité</ng-container>
    <i
      class="pi pi-question-circle"
      style="margin-left: 5px"
      tabindex="0"
      (mouseenter)="creativityTooltip.show($event)"
      (focus)="creativityTooltip.show($event)"
      (mouseout)="creativityTooltip.hide()"
      (blur)="creativityTooltip.hide()"
    ></i>
    <p-overlayPanel #creativityTooltip>
      <ng-container i18n="@@prompt_editor_temperature_tooltip"
        >Une valeur faible produit des réponses plus conservatrices et cohérentes,<br />
        tandis qu'une valeur élevée génère des réponses plus créatives et diversifiées.<br />
        Attention aux hallucinations.</ng-container
      >
    </p-overlayPanel>
  </div>
  <p-inputNumber
    [(ngModel)]="temperature"
    [minFractionDigits]="1"
    mode="decimal"
    [min]="0"
    [max]="1"
  />
</div>
<p-slider
  class="w-full"
  [(ngModel)]="temperature"
  [min]="0"
  [max]="1"
  [step]="0.01"
/>
@if (searchEnabled) {
  <div class="mt-4 mb-2 flex align-items-center">
    <label
      class="mr-2 mb-0"
      for="promptSearchAnchorCheckbox"
    >
      <ng-container i18n="@@assistant_settings_search_anchor_label"> Ancrage des recherches </ng-container>
    </label>
    <i
      class="pi pi-question-circle"
      style="margin-right: 0.5rem; cursor: pointer"
      tabindex="0"
      (mouseenter)="anchorTooltip.show($event)"
      (focus)="anchorTooltip.show($event)"
      (mouseout)="anchorTooltip.hide()"
      (blur)="anchorTooltip.hide()"
    ></i>
    <p-overlayPanel
      #anchorTooltip
      [style]="{ width: '260px' }"
    >
      <ng-container i18n="@@assistant_settings_search_anchor_tooltip_enabled">
        Activer l’ancrage des recherches avec le modèle {{ selectedModelDisplayName }}.
      </ng-container>
    </p-overlayPanel>
    <p-checkbox
      inputId="promptSearchAnchorCheckbox"
      [(ngModel)]="searchGrounding"
      binary="true"
      [disabled]="!searchEnabled"
    />
  </div>
}
<div class="mt-4 mb-2 flex align-items-center">
  <ng-container i18n="@@prompt_editor_context_label">Contexte</ng-container>
  <app-add-files-popup (filesSelected)="onFileSelected($event)" />
</div>
<app-extensible-textarea
  class="mb-4"
  [rows]="5"
  [invalid]="context === ''"
  [(text)]="context"
/>
@if (contextFiles && contextFiles.length > 0) {
  <div>
    <span i18n="@@chat_line_files_text">Fichiers:</span>&nbsp;
    @for (file of contextFiles; track file) {
      <p-chip
        class="m-2"
        [label]="file.filename"
        [removable]="true"
        (onRemove)="removeContextFile(file.id)"
      />
    }
  </div>
}
<div class="mb-2 flex align-items-center">
  <ng-container i18n="@@prompt_editor_prompt_label">Prompt utilisateur</ng-container>
</div>
<app-extensible-textarea
  class="mb-4"
  [rows]="5"
  [invalid]="prompt === ''"
  [(text)]="prompt"
/>
<div class="flex gap-2 justify-content-end">
  <p-button
    (onClick)="savePrompt()"
    [disabled]="!promptLabel || !model || !context || !prompt"
  >
    {{ dynamicButtonLabel }}
  </p-button>
  <p-button
    severity="warning"
    (onClick)="ref.close()"
  >
    <ng-container i18n="@@prompt_editor_cancel_button_label">Annuler</ng-container>
  </p-button>
</div>
